import Vue from 'vue'
import Router from 'vue-router'
const _import = require('./_import_development')
import Fetch from 'utils/login-fetch.js'

/* 按需加载 */
const Framework = r => require.ensure([], () => r(require('@/views/framework.vue')), 'chunkname1')
const Earth = r => require.ensure([], () => r(require('@/views/earth.vue')), 'chunkname1')
//登陆页面
const Login = r => require.ensure([], () => r(require('@/views/login/login.vue')), 'chunkname2')
//产业总览
const Dashboard = r => require.ensure([], () => r(require('@/views/framework/dashboard.vue')), 'chunkname1')

const Map = r => require.ensure([], () => r(require('@/views/map.vue')), 'chunkname1')
//产品成果
const ProductResults = r => require.ensure([], () => r(require('@/views/framework/product_results.vue')), 'chunkname2');
//产业图谱
const IndustrialAtlas = r => require.ensure([], () => r(require('@/views/framework/industrial_atlas.vue')), 'chunkname2');
//知识产权
const PropertyRight = r => require.ensure([], () => r(require('@/views/framework/intellectual_property_right.vue')), 'chunkname2');
//产业资本
const IndustrialCapital = r => require.ensure([], () => r(require('@/views/framework/industrial_capital.vue')), 'chunkname2');
//对标园区
const BidPack = r => require.ensure([], () => r(require('@/views/framework/bid_park')), 'chunkname2');



//政策动态
const Policy = r => require.ensure([], () => r(require('@/views/framework/policy.vue')), 'chunkname2');

//专业平台
const Platform = r => require.ensure([], () => r(require('@/views/framework/platform.vue')), 'chunkname2');



//高端人才
const Talent = r => require.ensure([], () => r(require('@/views/framework/talent.vue')), 'chunkname2');
Vue.use(Router)

export const constantRouterMap = [
    {
        path: '/login', component: Login, hidden: true
    },
  {
    path: '/',
    component: Earth,
    hidden: true,
    children: [
      {
        path: '/home',
        component: Framework,
        hidden: true ,
        children: [
          {path: '/', redirect:'dashboard', hidden: true },
          {path: 'dashboard', component: Dashboard, hidden: true },
          {path: 'map', component: Map, hidden: true },
          {path: 'propertyRight', component: PropertyRight, hidden: true},
          {path: 'industrialAtlas', component: IndustrialAtlas, hidden: true},
          {path: 'capital', component: IndustrialCapital, hidden: true},
          {path: 'productResults', component: ProductResults, hidden: true},
          {path: 'bidpack', component: BidPack, hidden: true},
          {path: 'policy', component: Policy, hidden: true},
          {path: 'platform', component: Platform, hidden: true},
          {path: 'talent', component: Talent, hidden: true},
        ]
    },
    ],

  },

]
var router = new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({y: 0}),
    routes: constantRouterMap
});
router.beforeEach((to, from, next) => {
  var   url=window.location.origin;
  var ticket = decodeURIComponent((new RegExp('[?|&]' + 'ticket' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
  if(ticket){
      url=url.split('?')[0];
      Fetch({
          url: '/user-center/user/ticket-login',
          data: {ticket,service:url,entry:1,},
      }).then(res=>{
          window.localStorage.setItem('xhqstoragetoken',res.token);
          window.location.href=url+'/';
      }).catch(error=>{
          console.log(error)
      });
  }else{
    let token =  window.localStorage.getItem('xhqstoragetoken');
    if (token) {
        next();
    } else {
      window.location.href=process.env.BASE_URL+'?service='+url;
      next();
    }
  }
})
/*router.beforeEach((to, from, next) => {
    var token = window.localStorage.getItem('xhqstoragetoken');
    /!*var permission = Cookies.get('permission') && JSON.parse(Cookies.get('permission'))
    console.log(permission)*!/
    if(!token) {
        next('/login')
    }
});*/
export default router



// WEBPACK FOOTER //
// ./src/router/index.js